/**
 * @param {(string|boolean)[]} classNames - Array of class names (false entries are filtered out)
 * @returns {string} Space-joined class string
 */
const getClassName = (classNames) => {
    return classNames
        .map((className) => {
            if (className !== false) {
                return className;
            }
            return false;
        })
        .join(" ");
};

export default getClassName;
